var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgT4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9741 22.9412H6.02574C5.75164 22.9412 5.52942 22.719 5.52942 22.4449C5.52942 22.1708 5.75164 21.9485 6.02574 21.9485H21.9741C22.2482 21.9485 22.4705 22.1708 22.4705 22.4449C22.4705 22.719 22.2482 22.9412 21.9741 22.9412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03674 22.9412H7.05146C6.77736 22.9412 6.55515 22.7189 6.55515 22.4448V18.8052C6.55515 18.349 6.92623 17.978 7.38234 17.978H8.70586C9.16198 17.978 9.53306 18.349 9.53306 18.8052V22.4448C9.53306 22.7189 9.31084 22.9412 9.03674 22.9412ZM7.54778 21.9485H8.54042V18.9706H7.54778V21.9485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0073 22.9412H11.022C10.7479 22.9412 10.5257 22.7189 10.5257 22.4448V17.614C10.5257 17.1579 10.8968 16.7868 11.3529 16.7868H12.6764C13.1325 16.7868 13.5036 17.1579 13.5036 17.614V22.4448C13.5036 22.7189 13.2814 22.9412 13.0073 22.9412ZM11.5183 21.9485H12.511V17.7794H11.5183V21.9485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9779 22.9412H14.9926C14.7185 22.9412 14.4963 22.719 14.4963 22.4449V15.7942C14.4963 15.3381 14.8674 14.967 15.3235 14.967H16.647C17.1031 14.967 17.4742 15.3381 17.4742 15.7942V22.4449C17.4742 22.719 17.252 22.9412 16.9779 22.9412ZM15.4889 21.9485H16.4816V15.9596H15.4889V21.9485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9484 22.9412H18.9631C18.689 22.9412 18.4668 22.719 18.4668 22.4449V12.4854C18.4668 12.0293 18.8379 11.6582 19.294 11.6582H20.6175C21.0737 11.6582 21.4447 12.0293 21.4447 12.4854V22.4449C21.4447 22.719 21.2225 22.9412 20.9484 22.9412ZM19.4595 21.9486H20.4521V12.6508H19.4595V21.9486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02574 16.6645C5.75164 16.6645 5.52942 16.4423 5.52942 16.1682C5.52942 15.8941 5.75164 15.6719 6.02574 15.6719C8.9443 15.6719 12.122 14.6091 14.9734 12.6793C17.5967 10.904 19.687 8.57657 20.7083 6.29386C20.8203 6.04365 21.1139 5.93155 21.3641 6.04355C21.6143 6.15549 21.7263 6.44908 21.6144 6.69929C20.5196 9.14605 18.3019 11.6253 15.5298 13.5014C12.5158 15.5412 9.14054 16.6645 6.02574 16.6645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9738 10.026C21.7547 10.026 21.5541 9.8798 21.4948 9.65805L20.8105 7.10428L18.2567 7.78857C17.9918 7.85958 17.7198 7.70241 17.6488 7.43764C17.5779 7.17287 17.735 6.90072 17.9998 6.82978L21.0329 6.01704C21.2978 5.94607 21.5699 6.10324 21.6408 6.36798L22.4535 9.40115C22.5245 9.66592 22.3674 9.93807 22.1026 10.009C22.0596 10.0205 22.0164 10.026 21.9738 10.026Z",
    fill: "#F6863C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9412,
    height: 16.9412,
    fill: "white",
    transform: "translate(5.52942 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT4);
export default __webpack_public_path__ + "static/media/t4.650d94042146cf0046acb5a79e7a77f6.svg";
export { ForwardRef as ReactComponent };